<template>
    <div class="title-card">
        <div class="title-card-header">
            <slot name="header">
            </slot>
        </div>
        <div class="title-card-body">
            <slot name="body">
            </slot>
        </div>
        <div class="title-card-footer">
            <slot name="footer">
            </slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'title-card',
};

</script>

<style lang="scss">

.title-card {
    border: 1px solid $color-neutral-light-500;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    text-align: center;

    &-header {
        margin-bottom: 0.5rem;
    }

    &-body {
        margin-bottom: 0.5rem;
    }

    &-footer {
        margin-bottom: 0.5rem;
    }
}

</style>
